var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.37 25.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#676766;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:0.97px;}.cls-2{stroke-width:0.97px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.82,9.71c.13,5.47-1.83,13-9.92,13S.84,15.18,1,9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.81,10.8c1.85-.36,4.87-.46,5.07,2.29.22,3.12-4.74,6.18-7.5,6m-1,2.56c2.41.33,3.95.84,3.95,1.41,0,1-4.67,1.81-10.41,1.81S.49,24.1.49,23.1C.49,22.53,2,22,4.43,21.69M12.33,15H16v4.77H12.33V15Zm1.84,0V9.71M13.49.49c-1.86,2.32,1.34,2.06-.46,5M8.8,2.93c-1.86,2.33,1.33,2.07-.46,5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaza);
export default __webpack_public_path__ + "static/media/taza.ad69e1890fe56eafcf70320c2e2bd362.svg";
export { ForwardRef as ReactComponent };